module.exports = "<div class=\"school-checkbox\">\n  <input id=\"checkbox-school-id1\" data-bind-target=\"school-checkbox-checkbox\" data-school-id=\"\" class=\"school-checkbox__checkbox\" type=\"checkbox\">\n  <label for=\"checkbox-school-id1\" data-bind-target=\"school-checkbox-label\" class=\"school-checkbox__label\"></label>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./app/views/partials/missions/school-checkbox.html
// module id = 631
// module chunks = 1